"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3070,7553],{

/***/ 82065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kw": function() { return /* binding */ getLandbotApi; },
/* harmony export */   "Zt": function() { return /* binding */ searchModelsApi; }
/* harmony export */ });
/* unused harmony exports getPoliciesApi, getBlogPosts, getChiSiamoApi, getPressApi */
/* harmony import */ var src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51377);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4022);


const getPoliciesApi = slug => request.get(`strapi/policies/${slug}`);
const getLandbotApi = code => src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(`strapi/landbots/${code}`);
const getBlogPosts = () => request.get('https://blog.carplanner.com/rss.xml', {
  responseType: 'text'
});
const getChiSiamoApi = () => request.get('strapi/chi-siamo');
const getPressApi = () => request.get('strapi/press-items');
const searchModelsApi = (path, term) => src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post(`${_constants__WEBPACK_IMPORTED_MODULE_1__/* .OFFERS_EXPLORER_SERVICE_URI */ .PT}/${path}`, {
  term
});

/***/ }),

/***/ 63070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39653);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20979);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83292);
/* harmony import */ var _choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59891);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3382);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75159);
/* harmony import */ var server_api_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82065);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


const _excluded = ["items", "apiPath", "onSelect", "placeholder", "notFoundText", "withOverlay", "disableFilter", "resultFormatter"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











const Autocomplete = _ref => {
  let {
    items,
    apiPath,
    onSelect,
    placeholder,
    notFoundText,
    withOverlay,
    disableFilter,
    resultFormatter
  } = _ref,
      styleProps = (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  const {
    isOpen,
    onOpen,
    onClose
  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useDisclosure */ .qY)();
  const searchInputElement = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const modalClosedFocusRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const {
    0: searchTerm,
    1: setSearchTerm
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  let itemsRepo = apiPath ? searchTerm : items;
  const searchInputChangeHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async target => {
    const {
      value
    } = target;

    if (apiPath && value.length >= MIN_STRING_LENGTH) {
      let found = await (0,server_api_common__WEBPACK_IMPORTED_MODULE_6__/* .searchModelsApi */ .Zt)(apiPath, value);

      if (found && found.data) {
        itemsRepo = found.data.map(resultFormatter || (_ref2 => {
          let {
            name,
            code
          } = _ref2;
          return {
            label: name,
            value: code
          };
        }));
      }

      setSearchTerm(itemsRepo);
    }
  }, []);
  const MIN_STRING_LENGTH = 2;

  const searchInputFocusHandler = () => {
    if (withOverlay) {
      if (searchInputElement && searchInputElement.current) {
        searchInputElement.current.style.zIndex = '1401'; // modal z-index + 1
      }

      onOpen();
    }
  };

  const onModalClose = () => {
    if (withOverlay) {
      if (searchInputElement && searchInputElement.current) {
        searchInputElement.current.style.zIndex = '1';
      }

      onClose();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .InputGroup */ .BZ, _objectSpread(_objectSpread({
      size: "lg",
      display: "block",
      ref: searchInputElement,
      onFocus: searchInputFocusHandler,
      borderColor: src_themes__WEBPACK_IMPORTED_MODULE_8__/* .theme.colors.borders.grey */ .r.colors.borders.grey,
      className: "searchAutoComplete"
    }, styleProps), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_2__/* .AutoComplete */ .Qc, {
        onChange: onSelect,
        emptyState: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("em", {
          children: notFoundText || ''
        }),
        filter: disableFilter ? () => true : null,
        shouldRenderSuggestions: value => value.length >= MIN_STRING_LENGTH,
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_2__/* .AutoCompleteInput */ .Vp, {
          size: "lg",
          placeholder: placeholder,
          borderRadius: "4px",
          className: "auto-complete-input",
          onChange: _ref3 => {
            let {
              target
            } = _ref3;
            return searchInputChangeHandler(target);
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_2__/* .AutoCompleteList */ .Jm, {
          borderRadius: "4px",
          mt: "0",
          maxWidth: "100%",
          children: itemsRepo.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_2__/* .AutoCompleteItem */ .Gb, {
            value: item.value,
            label: `${item.label}`,
            textAlign: "left",
            children: `${item.label.substring(0, 70)}…`
          }, `option-${item.value}`))
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .InputRightElement */ .xH, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_9__/* .SearchIcon */ .W1, {
          color: "baseNeutral.400"
        })
      })]
    })), withOverlay && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Modal */ .u_, {
      isOpen: isOpen,
      onClose: onModalClose,
      trapFocus: false,
      finalFocusRef: modalClosedFocusRef,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ModalOverlay */ .ZA, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .ModalContent */ .hz, {
        display: "none",
        top: "-1000px",
        left: "-1000px"
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Autocomplete);

/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

}]);